import React from 'react';
import * as R from 'ramda';
import { injectTool } from '../../initializers/injectors';
import SetAddressFormat from './component';


const registerSetAddressFormat = R.pipeP(
  injectTool('SetAddressFormat', ({ instance }) => ({
    type: 'customElement',
    title: 'Set Address Format',
    render: () => (
      <SetAddressFormat
        annotManager={instance.annotManager}
        instance={instance}
        signers={instance.getSigners()}
      />
    ),
  }))
);


export default registerSetAddressFormat;
